import React from "react";
import {
  createTopic,
  updateTopic,
  getTopicDetail,
} from "../../helpers/backend_helper";
import CodeDetail from "../Standards/CodeDetail";

const TopicDetail = (props) => (
  <CodeDetail
    {...props}
    codeLabel="Checklist Topic"
    getCodeDetail={getTopicDetail}
    createCode={createTopic}
    updateCode={updateTopic}
  />
);

export default TopicDetail;
